<template>
 <div style="margin-top:5px;">
  <v-card>
    <v-overlay :value="$store.state.isloading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
   <v-card-title>
    <v-row>
        <v-col md="5">
               Plano curricular
         </v-col>
          <v-col md="4">
            <v-combobox
              label="Selecione o curso"
              :items="cursos"
              item-text="descricao"
              item-value="idCurso"
               v-model="cursoSelected"
               @change="FiltrarDisciplinas()"
             >
            </v-combobox>
          </v-col>
          <v-col md="2">
            <v-combobox
              label="Selecione o anolectivo"
              :items="Listaranoslectivo"
              item-text="novadescricao"
              item-value="idCurso"
               v-model="anolectivoSelected"
               @change="FiltrarDisciplinas()"
            >
            </v-combobox>
          </v-col>
          <v-col md="1">
            <v-btn @click="menucomponente=1" fab small color="pink" style="color:white;" v-if="disciplinasPrimeiroAno.length && disciplinasSegundoAno.length && disciplinasTerceiroAno.length && disciplinasQuartoAno.length">
              <v-icon>print</v-icon>
            </v-btn>
          </v-col>
      </v-row>
   </v-card-title>
    <v-row>
      <v-col md="6">
          <v-card>
              <h5>10ª Classe</h5>
              <table class="tabela_responsiva_container table-bordered">
                <thead class="tabela_responsiva_thead">
                  <tr class="tabela_responsiva_tr">
                    <th scope="col" class="tabela_responsiva_th numeracaoDisciplina">#</th>
                    <th scope="col" class="tabela_responsiva_th_full tabela_responsiva_th">Descrição</th>
                    <th scope="col" class="tabela_responsiva_th_full tabela_responsiva_th numeracaoDisciplina">Bienal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tabela_responsiva_tr" v-for="(item, i) in disciplinasPrimeiroAno" :key="i">
                    <th data-label="#" scope="row" class="tabela_responsiva_esconder">{{ i + 1 }}</th>
                    <td data-label="Discíplina" class="tabela_responsiva_td tabela_responsiva_alinhaEsquerda" :style="'color:'+item.autor">{{ item.descricao }}</td>
                    <td data-label="Semestre" class="tabela_responsiva_td">{{ item.bienal }}</td>
                  </tr>
                </tbody>
              </table>
          </v-card>
      </v-col>
      <v-col md="6">
          <v-card>
              <h5>11ª Classe</h5>
              <table class="tabela_responsiva_container table-bordered">
                <thead class="tabela_responsiva_thead">
                  <tr class="tabela_responsiva_tr">
                    <th scope="col" class="tabela_responsiva_th numeracaoDisciplina">#</th>
                    <th scope="col" class="tabela_responsiva_th_full tabela_responsiva_th">Descrição</th>
                    <th scope="col" class="tabela_responsiva_th_full tabela_responsiva_th numeracaoDisciplina">Bienal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tabela_responsiva_tr" v-for="(item, i) in disciplinasSegundoAno" :key="i">
                    <th data-label="#" scope="row" class="tabela_responsiva_esconder">{{ i + 1 }}</th>
                    <td data-label="Discíplina" class="tabela_responsiva_td tabela_responsiva_alinhaEsquerda" :style="'color:'+item.autor">{{ item.descricao }}</td>
                    <td data-label="Semestre" class="tabela_responsiva_td">{{ item.bienal }}</td>
                  </tr>
                </tbody>
              </table>
          </v-card>
      </v-col>
      <v-col md="6">
          <v-card>
              <h5>12ª Classe</h5>
              <table class="tabela_responsiva_container table-bordered">
                <thead class="tabela_responsiva_thead">
                  <tr class="tabela_responsiva_tr">
                    <th scope="col" class="tabela_responsiva_th numeracaoDisciplina">#</th>
                    <th scope="col" class="tabela_responsiva_th_full tabela_responsiva_th">Descrição</th>
                    <th scope="col" class="tabela_responsiva_th_full tabela_responsiva_th numeracaoDisciplina">Bienal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tabela_responsiva_tr" v-for="(item, i) in disciplinasTerceiroAno" :key="i">
                    <th data-label="#" scope="row" class="tabela_responsiva_esconder">{{ i + 1 }}</th>
                    <td data-label="Discíplina" class="tabela_responsiva_td tabela_responsiva_alinhaEsquerda" :style="'color:'+item.autor">{{ item.descricao }}</td>
                    <td data-label="Semestre" class="tabela_responsiva_td">{{ item.bienal }}</td>
                  </tr>
                </tbody>
              </table>
          </v-card>
      </v-col>
      <v-col md="6">
          <v-card>
              <h5>13ª Classe</h5>
              <table class="tabela_responsiva_container table-bordered">
                <thead class="tabela_responsiva_thead">
                  <tr class="tabela_responsiva_tr">
                    <th scope="col" class="tabela_responsiva_th numeracaoDisciplina">#</th>
                    <th scope="col" class="tabela_responsiva_th_full tabela_responsiva_th">Descrição</th>
                    <th scope="col" class="tabela_responsiva_th_full tabela_responsiva_th numeracaoDisciplina">Bienal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tabela_responsiva_tr" v-for="(item, i) in disciplinasQuartoAno" :key="i">
                    <th data-label="#" scope="row" class="tabela_responsiva_esconder">{{ i + 1 }}</th>
                    <td data-label="Discíplina" class="tabela_responsiva_td tabela_responsiva_alinhaEsquerda" :style="'color:'+item.autor">{{ item.descricao }}</td>
                    <td data-label="Semestre" class="tabela_responsiva_td">{{ item.bienal }}</td>
                  </tr>
                </tbody>
              </table>
          </v-card>
      </v-col>
    </v-row>
  </v-card>
  <planocurricular :disciplinas="this.disciplinas" :curso="this.cursoSelected" :anolectivo="this.anolectivoSelected" @fecharComponente="fecharTelaComponente" v-if="menucomponente===1" />
 </div>
</template>

<script>
import axios from '../../plugins/axios'
import planocurricular from '../tec-ped/componentes/planocurricular.vue'
import Swal from 'sweetalert2'
const ls = require('local-storage')

export default {
  components: {
    planocurricular
  },
  data: function () {
    return {
      menucomponente: 0,
      disciplinas: [],
      cursos: [],
      overlay: false,
      isLoading: false,
      cursoSelected: null,
      anolectivoSelected: null,
      readImage: ls.get('urlReport') + `readfile/`,
      disciplinasPrimeiroAno: [],
      disciplinasSegundoAno: [],
      disciplinasTerceiroAno: [],
      disciplinasQuartoAno: [],
      disciplinasBienalColor: [],
      Listaranoslectivo: [],
      cores: [
        { cor: '#fc4503', chave: '' }, { cor: '#03c2fc', chave: '' }, { cor: '#d4c415', chave: '' }, { cor: '#17ad4b', chave: '' }, { cor: '#17ada0', chave: '' },
        { cor: '#2354cf', chave: '' }, { cor: '#cf239b', chave: '' }, { cor: '#cf7c23', chave: '' }, { cor: '#23cfc1', chave: '' }, { cor: '#23cfc1', chave: '' },
        { cor: '#808080', chave: '' }, { cor: '	#ffbf00', chave: '' }, { cor: '#aa23cf', chave: '' }, { cor: '#cf23a7', chave: '' }, { cor: '#cf2373', chave: '' }
      ],
      tempCores: [
        { valor: '' }
      ]
    }
  },

  mounted () {

  },

  computed: {
    role () {
      return ls.get('role')
    },
    isModeloIMS () {
      return this.modelo.id === 2 ? ls.get('i_id') : 1
    }
  },

  created () {
    this.initializeCursos()
    this.initializeAnosLectivo()
    this.initializedisciplinas()
  },

  methods: {
    async initializeCursos () {
      try {
        this.cursos = await axios.get('/cursoFindAll').then(res => res.data)
      } catch (error) {
      }
    },

    async FiltrarDisciplinas () {
      if (this.anolectivoSelected !== null) {
        this.disciplinasPrimeiroAno = this.disciplinas.filter(d => d.anoacademico === 1 && d.idCurso === this.cursoSelected.idCurso && d.anolectivo === this.anolectivoSelected.descricao)
        this.disciplinasSegundoAno = this.disciplinas.filter(d => d.anoacademico === 2 && d.idCurso === this.cursoSelected.idCurso && d.anolectivo === this.anolectivoSelected.descricao)
        this.disciplinasTerceiroAno = this.disciplinas.filter(d => d.anoacademico === 3 && d.idCurso === this.cursoSelected.idCurso && d.anolectivo === this.anolectivoSelected.descricao)
        this.disciplinasQuartoAno = this.disciplinas.filter(d => d.anoacademico === 4 && d.idCurso === this.cursoSelected.idCurso && d.anolectivo === this.anolectivoSelected.descricao)
      }
    },

    async initializeAnosLectivo () {
      this.isLoading = true
      try {
        this.Listaranoslectivo = await axios.get('/listarAnoLectivoAll').then((res) => res.data)
      } catch (error) {
        Swal.fire('Informação', '<p>Erro ao carregar os anos lectivos!</p>', 'error')
      } finally {
        this.isLoading = false
      }
    },

    filtrarDisciplinasBienais () {
      this.disciplinas.forEach(element => {

      })
    },

    async initializedisciplinas () {
      try {
        this.isLoading = true
        this.disciplinas = await axios
          .get('/disciplinaFindAllPlanoCurricular')
          .then(res => res.data)
        this.isLoading = false
        if (this.disciplinas.length) {
          this.disciplinas.forEach(element => {
            if (parseInt(element.bienal) > 0) {
              let index = this.disciplinas.indexOf(element)
              let indexCor = (this.tempCores.filter(c => c.valor == (element.descricao + '' + element.idCurso)).length)
              let chave = element.descricao + '' + element.idCurso
              if (indexCor == 0) {
                let randomValue = Math.floor(Math.random() * 10) + 0
                this.tempCores.push({ valor: chave, cor: this.cores[randomValue].cor })
                this.cores[randomValue].chave = chave
                this.disciplinas[index].autor = this.cores[randomValue].cor
              } else {
                this.disciplinas[index].autor = this.tempCores.filter(c => c.valor == chave)[0].cor
              }
            }
          })
        }
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    descricaoBienal (bienal) {
      return parseInt(bienal) > 0 ? 'Sim' : ''
    },

    descricaoEstadoBienal (bienal) {
      let bienal_ = parseInt(bienal)
      if (bienal_ == 1) {
        return 'Continua na classe seguinte'
      } else {
        if (bienal_ > 1) { return 'Continuação da classe anterior' } else { return '' }
      }

      // return 'Continuação da classe anterior'
    },
    fecharTelaComponente () {
      this.menucomponente = 0
    }
  }
}
</script>

<style scoped>
#texto {
  font-size: 16px;
  font-weight: bold;
  color: #006699;
}
.numeracaoDisciplina {
  width: auto !important;
}
.cardListaPorAno {
  width: 100%;
  height: auto;
  padding: 2px;
  margin: 0 auto 10px;
}
.cardContainerPorAno {
  margin-top: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
.cardListaPorAno h1 {
  text-align: center;
  font-size: 1.5em;
  font-weight: bold;
  margin: 5px auto 10px;
}
.elbuttonStyle {
  float:right;
}
.secondSpanStyle {
  font-weight:bold;
  margin-left: 1px;
}

.vermelho{
  color: #006699;
}

.amarelo{
  background-color: yellow;
  color: white;
}
</style>
